// extracted by mini-css-extract-plugin
export default {"storyItem":"c-b_ah","storyItem__circle":"c-b_ai","storyItem__image":"c-b_aj","storyItem__description":"c-b_ak","storyItem_viewAll":"c-b_al"};